export const environment = {
  production: true,
  environment_name: 'capegate',
  environment_title: 'Capegate',
  environment_url: 'https://capegatecentre.co.za/',
  environment: 'prod',
  api_base_url: 'https://api.hyprop.co.za/',
  api_auth_url: 'https://auth-api.hyprop.co.za/',
  cdn_url: 'https://cdn.hyprop.co.za/',
  mall_id: '93a44011-717d-4fc1-99df-52dbbdde6c1b',
  addressLat: -33.85252703045184,
  addressLng: 18.696810682259322,
  recaptcha_key: '6LeJuCcbAAAAAMiZ_rBgq7NTiEQVrjNZ1J6f1zAL',
  social_google_key:
    '150343683952-08m97b42cr2fc2v4j1qnckfmq1np0hn9.apps.googleusercontent.com',
  social_facebook_key: '253233436432992',
  sso_url: 'https://sso.hyprop.co.za',
  google_verification: 'ls63DYE3g-gIGOeW4g3QD0wAmtZwbHpMxHvCDkoiDJ0',
  street_address: 'Cnr Okavango & de Bron Rd, Brackenfell',
  address_locality: 'Cape Town',
  postal_code: '7562',
  address_country: 'ZA',
  contact_form_uuid: 'xrkkf3dd',
  google_api_key: 'AIzaSyCEvUD2-2IuJdnY4mCmiPHjrdjDsskcTG8',
  form4_link:
    'https://cdn.hyprop.co.za/document/2024/2/19/b2213e98-9cbe-4799-9eb2-b336daeca01f/11e16c5e-b384-447e-b767-91e6055fccf1.pdf',
  tiktok_url: 'https://www.tiktok.com/@capegatecentre',
  sitemap_image:
    'https://cdn.hyprop.co.za/image/2026/7/21/11615910-8023-408d-ab3c-973711b993ba/691aa1db-5ac6-4db2-8d3f-223f829c0bb2.jpg',
  error_image:
    'https://cdn.hyprop.co.za/image/2026/7/20/497da1ca-642c-4ec2-87dc-75c7d0b3edd2/1398f4bb-2ff1-4545-8ae8-2d32d3d666af.jpg',
};
